import {
  GET_TITLES_LOADING,
  GET_TITLES_SUCCESS,
  GET_TITLES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getTitlesUrl } from "api/apiUrls";

export const getTitlesAction = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: GET_TITLES_LOADING, payload: true });
    const response = await listItemsService(`${getTitlesUrl}`);

    dispatch({ type: GET_TITLES_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: GET_TITLES_FAILURE, payload: err });
  } finally {
    dispatch({ type: GET_TITLES_LOADING, payload: false });
  }
};
